export * from './getGraphQLEndpoint';
